import { useState, useCallback } from 'react';

const useVenueSelection = () => {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  const deselectMultiple = useCallback((ids: string[]) => {
    setSelectedIds(oldState => {
      const updatedState = new Set(oldState);

      for (const id of ids) {
        updatedState.delete(id);
      }
      return updatedState;
    });
  }, []);

  const selectMultiple = useCallback((ids: string[]) => {
    setSelectedIds(oldState => new Set([...oldState, ...ids]));
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedIds(new Set());
  }, []);

  return { selectedIds, deselectMultiple, selectMultiple, clearSelection };
};

export default useVenueSelection;
